import styled from "@emotion/styled";

export const StyledPromptContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  font-size: 0.625rem;
  color: #1c1b1f;

  & > div {
    width: 100%;
  }

  .ql-align-left {
    text-align: left !important;
  }

  .ql-align-center {
    text-align: center !important;
  }

  .ql-align-right {
    text-align: right !important;
  }

  .ql-align-justify {
    text-align: justify !important;
  }

  .ql-font-sans-serif {
    font-family: "Your Sans Serif Font", sans-serif !important;
  }

  .ql-font-serif {
    font-family: "Your Serif Font", serif !important;
  }

  .ql-font-monospace {
    font-family: "Your Monospace Font", monospace !important;
  }
`;

import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  promptLabel: {
    fontSize: "0.625rem",
    color: "#767676",
    flexShrink: 0,
    textWrap: "nowrap",
  },
}));
